import _ from 'lodash';
import {
  I18_NEXT_LNG,
  WEBSITE_SELECTED,
} from '../types';
import { getStorage, LocalStorage } from '../../utils/storage';
import {
  queryAllCatalogsContents,
  queryCatalogs,
  queryCatalogsContentList,
  queryCatalogsContents,
  queryCatalogsHistory,
  queryTreeCatalogs,
} from '../../_db/cms.service';

// CMS-栏目树信息查询
export const queryCatalogList = () => async (dispatch, getState) => {
    const { account: { website } } = getState();
    const { selected } = website || {};
    const { cmsSiteId, defaultLanguageCode } = getStorage(WEBSITE_SELECTED) || selected || {};
    const { code, data } = await queryCatalogs({ siteId: cmsSiteId, i18n: LocalStorage.get(I18_NEXT_LNG) || defaultLanguageCode }) || {};
   
    if (code && code === 200) {
      return { code, data }
    }
    return {}
};

// CMS-查詢子栏目树信息By父欄目ContentCode
export const queryCatalogChildrenTrees = ({ contentCode }) => async (dispatch, getState) => {
    const { account: { website } } = getState();
    const { selected } = website || {};
    const { cmsSiteId, defaultLanguageCode } = getStorage(WEBSITE_SELECTED) || selected || {};
    const { code: success, data } = await queryTreeCatalogs({ siteId: cmsSiteId, i18n: LocalStorage.get(I18_NEXT_LNG) || defaultLanguageCode, contentCode }) || {};
    if (success && success === 200) {
      return { success, data }
    }
    return {
      success: success === 200
    };
};


// CMS-栏目查询内容分頁列表
export const queryContentList = ({ contentCode, hasDetails, ruleTag, title, page, rowsPerPage }) => async (dispatch, getState) => {
    const { account: { website } } = getState();
    const { selected } = website || {};
    const { cmsSiteId, defaultLanguageCode } = getStorage(WEBSITE_SELECTED) || selected || {};

    const { code: success, data } = await queryCatalogsContentList({ siteId: cmsSiteId, contentCode, i18n: LocalStorage.get(I18_NEXT_LNG) || defaultLanguageCode, hasDetails, ruleTag, title, pageNum: page, pageSize: rowsPerPage }) || {};
    const { records, current, pages, size, total } = data || {};

    if (success && success === 200) {
      return {
        list: records,
        total,
        page: current,
        rowsPerPage: size,
        pages,
      }
    };
    return { success: success === 200 };
};

// CMS-栏目查询内容列表【無分頁】
export const queryContentRecords = ({ contentCode, hasDetails, ruleTag }) => async (dispatch, getState) => {
    const { account: { website } } = getState();
    const { selected } = website || {};
    const { cmsSiteId, defaultLanguageCode } = getStorage(WEBSITE_SELECTED) || selected || {};
    const { code: success, data } = await queryCatalogsContents({ siteId: cmsSiteId, contentCode, i18n: LocalStorage.get(I18_NEXT_LNG) || defaultLanguageCode, hasDetails, ruleTag }) || {};
    if (success && success === 200) {
        return { list: data };
    };
    return { success: success === 200, data };
};

// CMS-栏目查询所有子欄目内容列表
export const queryAllContentList = ({ contentCode, title, hasDetails, ruleTag, page, rowsPerPage }) => async (dispatch, getState) => {
  const { account: { website } } = getState();
  const { selected } = website || {};
  const { cmsSiteId, defaultLanguageCode } = getStorage(WEBSITE_SELECTED) || selected || {};
  const { code: success, data } = await queryAllCatalogsContents({ siteId: cmsSiteId, catalogs: contentCode, i18n: LocalStorage.get(I18_NEXT_LNG) || defaultLanguageCode, title, hasDetails, ruleTag, pageNum: page, pageSize: rowsPerPage }) || {};
  const { records, current, pages, size, total } = data || {};
  if (success && success === 200) {
      return {
        list: records,
        total,
        page: current,
        rowsPerPage: size,
        pages,
      };
  };
  return { success: success === 200, data };
};

// CMS-查询点击栏目記錄
export const queryCatalogsEventTracking = () => async (dispatch, getState) => {
  const { account: { website } } = getState();
  const { selected } = website || {};
  const { cmsSiteId, defaultLanguageCode } = selected || getStorage(WEBSITE_SELECTED) || {};
  const { code: success, data } = await queryCatalogsHistory({ siteId: cmsSiteId, i18n: LocalStorage.get(I18_NEXT_LNG) || defaultLanguageCode }) || {};
  if (success && success === 200) {
    return {
      list: data
    };
  };
  return { success: success === 200, data };
};

// CMS-[首頁]栏目查询列表
export const searchDashboardCatalogsList = ({ contentCode, level }) => async (dispatch, getState) => {
    const { account: { website } } = getState();
    const { selected } = website || {};
    const { cmsSiteId, defaultLanguageCode } = selected || getStorage(WEBSITE_SELECTED) || {};
    const { code, data } = await queryTreeCatalogs({ siteId: cmsSiteId, i18n: LocalStorage.get(I18_NEXT_LNG) || defaultLanguageCode, contentCode, level }) || {};
    if (code === 200) {
      dispatch({
        type: contentCode,
        payload: data
      });
    }
};


